export default __webpack_public_path__ + "static/media/jupiter.6b1089ed.svg";